import React, { useEffect, useState } from "react";
import "./App.css";
import { UnauthorizedUser, defineCustomElements } from "react-library";
import Router from "./routes";
import { useRecoilState, useRecoilValue } from "recoil";
import { getAccessToken } from "./services/common.service";
import LocaleService, {  TLang } from "./services/locale.service";
import { languageAtom } from "./state/atoms/language.atom";
import { translationAtom } from "./state/atoms/translations.atom";
import Loading from "./components/common/spinner.tsx/Loading";
import Clarity from "@microsoft/clarity";

/**
 * Define custom elements to use stencil components in the app.
 */
defineCustomElements();

const CLARITY_KEY = "pm0vfn9cpx";

function App() {
  const accessToken = getAccessToken();

  const selectedLanguage = useRecoilValue(languageAtom);
  const [locales, setLocales] = useRecoilState(translationAtom);  
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    Clarity.init(CLARITY_KEY);
    const userId = localStorage.getItem("farmUserId");
    if (userId) {
      Clarity.identify(userId);
    }
  }, []);  

  useEffect(() => {
    localStorage.setItem("user_language", selectedLanguage);
    if (accessToken) {
      fetchLocales(selectedLanguage);
    }
  }, [selectedLanguage]);

  const fetchLocales = async (lang: TLang = "en") => {
    try {
      setIsLoading(true);
      const locales = await LocaleService.getLocales(lang);
      if (locales) {
        setLocales(locales);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  if( accessToken && locales["LocalesNotFetchedYet"] !== undefined) {
    // return <div style={{textAlign: "center", paddingTop: "16px"}}>{t("Logging_you_in")}</div>;
    return <Loading message={"Logging you in ...."} />;
  }

  return (
    <div>
      <Router />
      {!isLoading && accessToken && (
        <div style={{ position: "absolute", zIndex: -1 }}>
          <UnauthorizedUser language={selectedLanguage} token={accessToken} />
        </div>
      )}
    </div>
  );
}

export default App;
